module.exports = __webpack_public_path__ + "static/salon-de-pasajeros---acabado-piso-3509cc70f942d7f5e90e2f7998a3ca1d.jpg";